export const environment = {
  production: false,
  eliquaRestURL: 'https://holmes.uat.qivos.net/ci-holmes-UAT/rest/v1/',
  clientName: 'holmes',
};
